var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandManagingC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .icon-managing-1 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-5);\r\n      }\r\n\r\n      .icon-managing-2 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1);\r\n      }\r\n\r\n      .icon-managing-3 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-3);\r\n      }\r\n\r\n      .icon-managing-4 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-4);\r\n      }\r\n\r\n      .icon-managing-5 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 91.05,
    y1: 87.94,
    x2: 28.91,
    y2: 25.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f89cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3f9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-2",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 106.55,
    y1: 72.43,
    x2: 44.42,
    y2: 10.29,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-3",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 73.06,
    y1: 105.92,
    x2: 10.92,
    y2: 43.79,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-4",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 90.56,
    y1: 88.42,
    x2: 28.42,
    y2: 26.29,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-5",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 89.49,
    y1: 89.49,
    x2: 27.35,
    y2: 27.35,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-managing-2",
    d: "m51.36,34.02v4.41h-29.75v-4.41h11.97v-3.57h5.67v3.57h12.11Zm-28.7-5.99c5.81-.46,8.44-2.1,9.42-3.71h-7.77v-4.41h24.4v4.41h-7.81c.94,1.61,3.57,3.26,9.42,3.71l-1.93,4.41c-6.51-.52-10.22-2.77-11.94-5.64-1.65,2.87-5.36,5.11-11.87,5.64l-1.92-4.41Zm25.24,17.64c0,3.75-4.34,5.88-11.48,5.88s-11.52-2.14-11.52-5.88,4.34-5.92,11.52-5.92,11.48,2.14,11.48,5.92Zm-5.74,0c0-1.26-1.75-1.71-5.74-1.71s-5.78.45-5.78,1.71,1.75,1.68,5.78,1.68,5.74-.42,5.74-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-managing-5",
    d: "m73.1,25.58h-19.32v-4.38h6.83v-2.8h5.67v2.8h6.83v4.38Zm-9.66,12.29c-4.8,0-8.19-2.42-8.19-5.88s3.4-5.85,8.19-5.85,8.19,2.38,8.19,5.85-3.4,5.88-8.19,5.88Zm10.85,1.23h5.6v12.04h-21.77v-12.04h5.6v1.93h10.57v-1.93Zm-10.85-5.32c1.65,0,2.77-.52,2.77-1.79s-1.12-1.79-2.77-1.79-2.77.56-2.77,1.79,1.12,1.79,2.77,1.79Zm10.85,11.48h-10.57v1.54h10.57v-1.54Zm9.7-14.42h-4.1v7.11h-5.67v-19.32h5.67v7.63h4.1v4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-managing-3",
    d: "m41.35,72.7c-6.76,1.3-14.25,1.44-19.85,1.47l-.49-4.41c1.65,0,3.5,0,5.46-.04v-5.95h5.57v5.78c3.05-.18,6.13-.42,8.96-.81l.35,3.96Zm-7.53-5.6c.46-2.66.6-4.83.63-6.69h-11.55v-4.45h17.15v2.21c0,2.38,0,5.6-.73,9.59l-5.5-.67Zm-2.49,14.46h17.89v4.45h-23.56v-10.05h5.67v5.6Zm20.37-18.27v4.59h-3.5v10.26h-5.67v-24.5h5.67v9.66h3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-managing-4",
    d: "m61.3,74.48c4.69-.07,8.51-.32,12.6-1.05l.56,4.55c-4.97.91-9.77,1.09-15.93,1.09h-3.01v-14h9.87v-4.38h-9.91v-4.45h15.68v13.23h-9.87v5.01Zm20.09-20.9v33.01h-5.67v-33.01h5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-managing-1",
    d: "m97.5,105H7.5c-4.14,0-7.5-3.36-7.5-7.5V7.5C0,3.36,3.36,0,7.5,0h90c4.14,0,7.5,3.36,7.5,7.5v90c0,4.14-3.36,7.5-7.5,7.5ZM7.5,5c-1.38,0-2.5,1.12-2.5,2.5v90c0,1.38,1.12,2.5,2.5,2.5h90c1.38,0,2.5-1.12,2.5-2.5V7.5c0-1.38-1.12-2.5-2.5-2.5H7.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandManagingC);
export default __webpack_public_path__ + "static/media/brand-managing-c.b0d6157d186ca43f6ad086ddef3144ab.svg";
export { ForwardRef as ReactComponent };